import type { AxiosError } from 'axios'
import type { ApiResponseError } from '../error-handling/ApiResponseError'

export type ApiResponse<T, U = unknown> =
  | [ApiResponseError<U>, undefined]
  | [undefined, T]

export interface ProblemDetails {
  /** A URI reference that identifies the specific occurrence of the problem (e.g. request/tracing ID) */
  traceId: string
  /** A URI reference [RFC3986] that identifies the problem type */
  type: string
  /** A short, human-readable summary of the problem type */
  title: string
  /** A human readable title. */
  friendlyTitle?: string
  /** The HTTP status code [RFC7231] */
  status: number
  /** A human-readable explanation specific to this occurrence of the problem */
  detail?: string
  /** A URI reference that identifies the specific occurrence of the problem (e.g. request/tracing ID) */
  instance?: string
  /** A list of errors that occurred during the request */
  errors?: Record<string, string[]>
  [key: string]: unknown
}

export function isProblemDetails(
  problemDetails: ProblemDetails | AxiosError | unknown
): problemDetails is ProblemDetails {
  return (
    (problemDetails as ProblemDetails).type !== undefined &&
    (problemDetails as ProblemDetails).title !== undefined &&
    (problemDetails as ProblemDetails).status !== undefined &&
    (problemDetails as ProblemDetails).traceId !== undefined
  )
}
